import { render, staticRenderFns } from "./LoginProviderV2.vue?vue&type=template&id=64696a56&scoped=true&"
import script from "./LoginProviderV2.vue?vue&type=script&lang=js&"
export * from "./LoginProviderV2.vue?vue&type=script&lang=js&"
import style0 from "./LoginProviderV2.vue?vue&type=style&index=0&id=64696a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64696a56",
  null
  
)

component.options.__file = "LoginProviderV2.vue"
export default component.exports